<template>
  <div>
    loading……
  </div>
</template>
<script>
  export default {
    route: {
      data ({to: { query: { auth_code, state } }}) {
        return
        /* eslint-disable */
        if (!auth_code) {
          window.alert('授权失败')
          return Promise.reject()
        }
        return this.$http.post('member/account', {
          code: auth_code,
          type: 'qy'
        })
        .then(() => {
        })
        .catch(() => {
          window.alert('授权失败')
        })
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** Login.vue?4b7c586e
 **/